import Gradient from '@ui/effects/Gradient'
import { colors } from '@ui/colors'
import { Image } from 'expo-image'
import React from 'react'
import { View } from 'react-native'

export default function Avatar() {
  return (
    <View className="aspect-square h-full w-auto overflow-hidden rounded-full">
      <Gradient colors={[colors.white75, colors.white10]} />
      <Image
        contentFit="contain"
        transition={300}
        style={{ width: '100%', height: '100%', position: 'absolute' }}
        source={require('@/images/avatar.png')}
      />
    </View>
  )
}
